<template>
    <div v-if="element && element.style && element.style.customCss" v-html="'<style>' + element.style.customCss + '</style>'"></div>
    <div class="sk-element-wrapper" :style="styleWrapper" :class="element.id + '-wrapper twpb-photo-wrapper'" v-if="element.props" @dblclick.stop="onClick()">
        <template v-if="element.props.image && element.props.image !== '' && element.props.image !== 'null'">
            <figure v-if="element.props.showTitle && element.props.title" class="twpb-photo-figure" style="display: inline-block; max-width: 100%; margin: 0">
                <img :src="element.props.image" :style="styleObject" :class="['twpb-photo', element.class, element.props.class, element.props.themeStyle]" />
                <figcaption class="twpb-photo-title" style="margin: 8px 0 0 0; font-style: italic; font-size: 14px; color: #6b7280; text-align: center">{{ element.props.title }}</figcaption>
            </figure>
            <img v-else :src="element.props.image" :style="styleObject" :class="['twpb-photo', element.class, element.props.class, element.props.themeStyle]" />
        </template>
        <template v-else>
            <div class="sk-not-selected-element">Add Photo</div>
        </template>
    </div>
</template>
<script>
export default {
    name: "Photo",
    props: {
        element: {
            required: true,
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit("onClick", this.element);
        },
    },
    computed: {
        styleObject() {
            const s = this.element.style;
            return {
                ...(s.width && s.width !== "0" && s.width !== "0px" && s.width !== "0%" && s.width !== "0rem" ? { width: s.width } : {}),
                ...(s.height && s.height !== "0" && s.height !== "0px" && s.height !== "0%" && s.height !== "0rem" ? { height: s.height } : {}),
                backgroundColor: s.backgroundColor,
                color: s.color,
                ...(s.objectFit && s.objectFit !== "none" ? { objectFit: s.objectFit } : {}),
                ...(s.borderRadius && s.borderRadius !== "0px 0px 0px 0px" ? { borderRadius: s.borderRadius } : {}),
                ...(s.border && String(s.border).trim() !== "" ? { border: s.border } : {}),
            };
        },
        styleWrapper() {
            const s = this.element.style;
            return {
                textAlign: s.textAlign,
                ...(s.padding && s.padding !== "0px 0px 0px 0px" ? { padding: s.padding } : {}),
                ...(s.margin && s.margin !== "0px 0px 0px 0px" ? { margin: s.margin } : {}),
            };
        },
    },
    emits: ["onClick"],
};
</script>
